export const questions = [ 
    {id: 1,
    category: "math",
    question: "What is the square root of 144?",
    options: ["12", "14", "16", "18"],
    answer: "12"
  },
  {
    id: 2,
    category: "react",
    question: "What is React?",
    options: ["A programming language", "A library for building user interfaces", "A database management system", "A framework for creating APIs"],
    answer: "A library for building user interfaces"
  },
  {
    id: 3,
    category: "math",
    question: "What is the value of pi?",
    options: ["3.14", "2.71", "1.41", "1.61"],
    answer: "3.14"
  },
  {
    id: 4,
    category: "logical",
    question: "If a plane crashes on the border of the USA and Canada, where do you bury the survivors?",
    options: ["USA", "Canada", "No need to bury them", "In the nearest cemetery"],
    answer: "No need to bury them"
  },
  {
    id: 5,
    category: "react",
    question: "What is a component in React?",
    options: ["A function that returns HTML", "A database table", "A server-side script", "A programming language"],
    answer: "A function that returns HTML"
  },
  {
    id: 6,
    category: "math",
    question: "What is the area of a circle with a radius of 5 units?",
    options: ["10 sq units", "25 sq units", "50 sq units", "78.5 sq units"],
    answer: "78.5 sq units"
  },
  {
    id: 7,
    category: "logical",
    question: "What is the next number in this sequence: 1, 1, 2, 3, 5, 8, 13, ...?",
    options: ["20", "21", "22", "23"],
    answer: "21"
  },
  {
    id: 8,
    category: "react",
    question: "What is JSX in React?",
    options: ["A syntax extension to JavaScript", "A server-side scripting language", "A database management system", "A machine learning library"],
    answer: "A syntax extension to JavaScript"
  },
  {
    id: 9,
    category: "math",
    question: "What is the value of x if 3x - 7 = 8?",
    options: ["5", "6", "7", "8"],
    answer: "5"
  },
  {
    id: 10,
    category: "logical",
    question: "What word starts with 'e', ends with 'e', but only contains one letter?",
    options: ["Eye", "envelope", "Ere", "Ese"],
    answer: "envelope"
  }
];
